export default __webpack_public_path__ + "media/images/features/jtb/ogp-2606eb985b984f5210bcce3449295c4a.jpg";